<template>
  <div class="footPage">
    <p>主办：北京正信民生科技创新服务联盟</p>
    <p>技术支持：北京易魔方科技集团有限公司</p>
    <p>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" tarrget="_blank">京ICP备18050245号-5</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102007553">京公网安备11010102007553号</a>
    </p>
  </div>
</template>
<script>
export default {
  name: "footPage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.footPage {
  width: 100%;
  height: 159px;
  background-image: linear-gradient(0deg,
    #4fa5ff 0%,
    #2791ff 100%);
  display: flex;
  justify-content:  center ;
  flex-direction: column;
  p {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    margin: 5px 0;
    a {
      font-size: 14px;
      color: #ffffff;
      margin-left: 20px;
    }
  }
}
</style>


